import type { RefObject } from "react";
import { ConfirmDialog } from "@common/ConfirmDialog";
import { ComponentColor } from "@common/types";

interface RecordBankReturnDialogProps {
    // The organization whose account the API suspends.
    customerName: string;
    isProcessing: boolean;
    // Inline failure copy from the parent's request; the dialog stays open.
    errorMessage: string | null;
    // True once the API refused (409): a retry is refused the same way.
    isRefused: boolean;
    // Where focus returns on close: the action disables its trigger during the
    // reload, and the reloaded order (Failed) no longer shows it.
    returnFocusRef: RefObject<HTMLElement | null>;
    onConfirm: () => void;
    onClose: () => void;
}

// Admin "Record bank return" (C-10). Each consequence below is what the API
// does on POST /orders/{id}/payment-return: the payment becomes Failed with $0
// paid, the organization is suspended and the customer is emailed.
export const RecordBankReturnDialog = ({
    customerName,
    isProcessing,
    errorMessage,
    isRefused,
    returnFocusRef,
    onConfirm,
    onClose,
}: RecordBankReturnDialogProps) => (
    <ConfirmDialog
        title="Record bank return?"
        body={
            <p>
                Only do this after confirming in Authorize.Net that the bank
                returned this payment. The order will show as unpaid,{" "}
                {customerName}'s account will be suspended, and they'll be
                emailed that their payment was returned.
            </p>
        }
        confirmLabel="Record return"
        confirmColor={ComponentColor.Error}
        dismissLabel="Cancel"
        isProcessing={isProcessing}
        confirmDisabled={isRefused}
        errorMessage={errorMessage}
        returnFocusRef={returnFocusRef}
        onConfirm={onConfirm}
        onClose={onClose}
    />
);
